// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XAhC","delete":"styles_delete__3--gh","update":"styles_update__3XrOf","add":"styles_add__IYwp_"};